"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (path, index) {
    return path.split('/')[index];
});
